const NAME = "GROUP_CLASSIFICATION";

export default NAME;
